import { scrollToTarget } from './scrolling';

const LandingSheet = (() => {

	const ls = {
		initialised: false,
		root: undefined,
		visibility: undefined,
		windowOuterHeight: undefined,
		liveFeed: undefined,
		isAnimating: false,
		scrollTriggers: [],
		triggerScrollEvents: [],
		hasCompleted: false,
	};

	ls.init = function() {
		const landing = document.querySelector('.landing');
		// only run once unless user makes a non-swup navigation
		if (ls.hasCompleted) {
			landing.remove();
			return;
		}

		const liveFeed = document.getElementById('live-feed');
		if (!landing || !liveFeed) {
			return;
		}

		ls.root = landing;
		ls.liveFeed = liveFeed;
		document.body.classList.add('has-landing');

		ls.setHeight();
		window.addEventListener('resize', ls.onWindowHeightChange);

		ls.triggerScrollEvents = ['pointerdown', 'touchstart', 'touchmove', 'wheel'];
		ls.setupScrollTriggers();

		ls.initialised = true;
	}

	ls.onTriggerScrollEvent = function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!ls.isAnimating) {
			ls.isAnimating = true;
			document.body.classList.remove('has-landing');
			document.body.classList.add('landing-leaving');
			window.removeEventListener('resize', ls.onWindowHeightChange);
			scrollToTarget(ls.liveFeed, {
				onComplete: () => {
					requestAnimationFrame(() => {
						ls.isAnimating = false;
						document.body.classList.remove('landing-leaving');
						ls.root.remove();
						window.scrollTo(0, 0);

						ls.hasCompleted = true;
						ls.unload();
					})
				},
			});
		}
	}

	ls.setupScrollTriggers = function() {
		const scrollTriggers = [ls.root.querySelector('.landing-content')];
		ls.scrollTriggers = scrollTriggers;

		ls.triggerScrollEvents.forEach(eventType => {
			ls.scrollTriggers.forEach(trigger => {
				trigger.addEventListener(eventType, ls.onTriggerScrollEvent, {passive: false})
			})
		})
	}

	ls.unloadScrollTriggers = function() {
		if (ls.scrollTriggers && ls.triggerScrollEvents) {
			ls.triggerScrollEvents.forEach(eventType => {
				ls.scrollTriggers.forEach(trigger => {
					trigger.removeEventListener(eventType, ls.onTriggerScrollEvent)
				})
			})
		}
	}

	ls.setHeight = function() {
		ls.root.style.height = window.innerHeight + 'px';
	}

	ls.onWindowHeightChange = function() {
		const newOuterHeight = window.outerHeight;
		if (newOuterHeight !== ls.windowOuterHeight) {
			ls.windowOuterHeight = newOuterHeight;

			ls.setHeight();
		}
	}

	ls.unload = function() {
		if (ls.initialised) {
			window.removeEventListener('resize', ls.onWindowHeightChange);
			ls.unloadScrollTriggers();

			ls.initialised = false;
			ls.root = undefined;
			ls.visibility = undefined;
			ls.windowOuterHeight = undefined;
			ls.liveFeed = undefined;
			ls.isAnimating = false;
			ls.triggerScrollEvents = [];
		}
	}

	return ls;

})();

export default LandingSheet;




// WEBPACK FOOTER //
// ./scripts/modules/landing-sheet.js